<template>
	<div id="activity-list-content-loading" class="vs-con-loading__container p-4">
		<div v-if="navbarOptions" class="vx-row">
			<div class="vx-col md:w-full">
				<label class="g-table--title" v-text="$t('Activity.AssignedActivities')"></label>
			</div>
		</div>
		<div class="vx-row flex items-center">
			<div v-if="navbarOptions" class="vx-col md:w-1/5 mt-2">
				<div class="o-span--count bg-primary" v-text="assignedActivities.length"></div>
			</div>
			<div v-if="navbarOptions" class="vx-col md:w-4/5 flex items-center justify-end mt-2">
				<vs-button
					type="border"
					color="#F9841E"
					style="padding: 0.3rem 2.5rem; font-size: 12px; line-height: 15px"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="activityListPopupMounted = true"
					>{{ $t("ButtonAddTypeConfig") }}
				</vs-button>
				<vx-tooltip
					v-if="assignedActivities.length > 1"
					class="cursor-pointer ml-4"
					color="primary"
					position="bottom"
					:title="$t('Crud.Delete')"
					:text="$t('Alarm.DeleteAllVisitPoints')"
				>
					<feather-icon
						class="g-label--normal"
						size="small"
						icon="TrashIcon"
						svgClasses="h-5 w-5 text-danger cursor-pointer"
						@click.stop="openDeleteAllConfirm"
					/>
				</vx-tooltip>
			</div>
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<hr v-if="navbarOptions" class="mt-2" style="border: 0.75px solid #a3a3a3" />
				<vs-table
					v-if="assignedActivities.length > 0"
					max-items="5"
					pagination
					ref="table"
					search
					:data="assignedActivities"
				>
					<div
						v-if="!navbarOptions"
						slot="header"
						class="flex flex-wrap-reverse items-center flex-grow justify-between"
					>
						<div class="flex items-center">
							<label class="g-table--title mr-2" v-text="$t('Activity.TotalActivities')"></label>
							<div class="o-span--count bg-primary" v-text="assignedActivities.length"></div>
						</div>
					</div>
					<template slot="thead">
						<vs-th v-if="enableHeadTable('name')" class="g-table--title">{{ $t("Name") }}</vs-th>
						<vs-th v-if="enableHeadTable('description')" class="g-table--title"
							>{{ $t("Description") }}
						</vs-th>
						<vs-th v-if="enableHeadTable('service_time')" class="g-table--title">
							{{ $t("Activity.ServiceTime") }}
						</vs-th>
						<vs-th v-if="enableHeadTable('active_form')" class="g-table--title"
							>{{ $t("Activity.Form") }}
						</vs-th>
						<vs-th v-if="enableHeadTable('action')" class="g-table--title" v-show="tableActions">
							{{ $t("Actions") }}
						</vs-th>
					</template>
					<template slot-scope="{data}">
						<tbody>
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td
									v-if="enableHeadTable('name')"
									class="g-table--description"
									:data="data[indextr].id"
								>
									{{ data[indextr].name }}
								</vs-td>
								<vs-td
									v-if="enableHeadTable('description')"
									class="g-table--description"
									:data="data[indextr].id"
								>
									{{ data[indextr].description }}
								</vs-td>
								<vs-td
									v-if="enableHeadTable('service_time')"
									class="g-table--description"
									:data="data[indextr].id"
								>
									{{ data[indextr].service_time }}
								</vs-td>
								<vs-td
									v-if="enableHeadTable('active_form')"
									class="g-table--description"
									:data="data[indextr].id"
								>
									<vs-chip
										:color="getOrderStatusColor(data[indextr].active_form)"
										class="product-order-status"
										>{{ withForm(data[indextr].active_form) }}
									</vs-chip>
								</vs-td>
								<vs-td
									v-if="enableHeadTable('action')"
									class="g-table--description"
									:data="data[indextr].id"
									v-show="tableActions"
								>
									<feather-icon
										class="g-label--normal"
										size="small"
										icon="Trash2Icon"
										svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
										:title="$t('Crud.Delete')"
										@click.stop="removeAssignedActivity(data[indextr].id)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p
					v-else
					class="g-label--normal text-center mt-4"
					v-text="$t('Resource.View.NotAssignedActivities')"
				></p>
			</vue-perfect-scrollbar>
		</div>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('ActivityList')"
			:active.sync="activityListPopupMounted"
		>
			<activity-list-view
				v-if="activityListPopupMounted"
				:customFunction="btnAssignHandleClick"
				:custom-config="activityListConfig"
			/>
		</vs-popup>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleActivity from "@/store/activity/moduleActivity.js";
import ActivityListView from "./ActivityListView.vue";
import PopupCustomize from "../../core/components/PopupCustomize";

export default {
	components: {
		PopupCustomize,
		VuePerfectScrollbar,
		ActivityListView,
	},
	props: {
		navbarOptions: {
			type: Boolean,
			default: true,
		},
		tableActions: {
			type: Boolean,
			default: false,
		},
		activityListIds: {
			type: Array,
			default: () => [],
		},
		assignedActivityListConfig: {
			type: Object,
			default: () => {
				return {
					columns: [
						"name",
						"description",
						"active_form",
						"service_time",
						"resource_id",
						"group_id",
						"action",
					],
				};
			},
		},
	},
	data() {
		return {
			activeItem: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			activityListPopupMounted: false,
			activityListConfig: {
				actionDropdown: false,
				btnAssignActivity: true,
				columns: ["name", "description", "active_form", "service_time", "resource_id", "group_id"],
				rowSelectionMultiple: true,
			},
		};
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		removeAssignedActivity(id) {
			this.$store.commit("moduleActivity/REMOVE_ASSIGNED_ACTIVITY", id);
		},
		async getAssignedActivitiesByIds(ids) {
			this.openLoadingContent("#activity-list-content-loading");
			await this.$store.dispatch("moduleActivity/fetchActivityPaginated", {
				id: ids,
				fields: ["id", "name", "description", "service_time", "active_form"],
			});
			this.closeLoadingContent("#activity-list-content-loading");
		},
		btnAssignHandleClick() {
			this.activityListPopupMounted = false;
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${this.$t("Activity.AssignedActivities")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleActivity/REMOVE_ALL_ASSIGNED_ACTIVITY");
		},
	},
	computed: {
		assignedActivities() {
			return this.$store.state.moduleActivity.assignedActivities;
		},
		withForm() {
			return (value) => {
				if (value === 0 || !value) {
					return this.$t("Activity.Inactivated");
				} else {
					return this.$t("Activity.Activated");
				}
			};
		},
		getOrderStatusColor() {
			return (status) => {
				if (status === 0 || !status) return "warning";
				if (status === 1 || status) return "success";
				return "primary";
			};
		},
		enableHeadTable() {
			return (headName) => this.assignedActivityListConfig.columns.includes(headName);
		},
	},
	created() {
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
	},
	mounted() {
		this.isMounted = true;
		if (this.activityListIds && this.activityListIds.length > 0) {
			this.getAssignedActivitiesByIds(this.activityListIds);
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleActivity/REMOVE_ALL_ASSIGNED_ACTIVITY");
	},
};
</script>

<style lang="scss" scoped>
.scroll-activity-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
</style>
